import { FETCH_ALL_SURVEYS, FETCH_ALL_SURVEYS_REQUEST, FETCH_ALL_SURVEYS_ERROR } from "../../constants/actionTypes";

const initialState = {
    allSurveys: [],
    loading: false,
    error: null
};

export default (survey = initialState, action) => {
    switch (action.type) {
        case FETCH_ALL_SURVEYS_REQUEST:
            return { ...survey, loading: true, error: null };

        case FETCH_ALL_SURVEYS:
            return { ...survey, allSurveys: action.payload, loading: false };

        case FETCH_ALL_SURVEYS_ERROR:
            return { ...survey, loading: false, error: action.payload };

        default:
            return survey;
    }
};
